import { usePathnameChange } from "#app/lib/hooks/use-pathname-change";

/**
 * The dialog-system default: an open overlay closes when the route changes
 * underneath it. Side panels are non-modal and click-behind, so a click
 * beside the panel can navigate; without this the panel floats over a page
 * it no longer belongs to. The one sanctioned exception is the issue view's
 * side panel, which keeps its own pattern list in `IssueViewProvider` so a
 * user can carry an issue with them across boards, lists and the map.
 */
export function useCloseOnNavigate(open: boolean, onClose: () => void) {
  usePathnameChange(() => {
    if (open) onClose();
  });
}
